var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
// ...existing code...
import { gql, useLazyQuery } from "@apollo/client"; // Changed from useLazyQuery
import { useEffect, useRef, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
var ALL_COMMUNITY_REQUESTS_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query AllCommunityRequestsQuery {\n    allCommunityRequests {\n      id\n      slug\n      __typename\n      title\n      name\n      isWriteable\n      created\n      isCompleted\n      description { id text }\n      likedBy {\n        id name slug __typename\n        photo { id url }\n      }\n      createdBy {\n        id name slug path __typename\n        openGraph { id image { id url } }\n        organisation {\n          id slug name path\n        }\n        photo {\n          id url\n        }\n      }\n      comments {\n        id __typename\n      }\n      embeds {\n        imageAssets {\n          id\n          slug\n          __typename\n          image {\n            id url url2x width height type\n          }\n        }\n        fileAssets {\n          id name slug __typename\n          file { id url formattedSize typeName }\n          thumbnail { id url url2x width height type }\n        }\n      }\n      type {\n        id name slug __typename\n      }\n    }\n  }\n"], ["\n  query AllCommunityRequestsQuery {\n    allCommunityRequests {\n      id\n      slug\n      __typename\n      title\n      name\n      isWriteable\n      created\n      isCompleted\n      description { id text }\n      likedBy {\n        id name slug __typename\n        photo { id url }\n      }\n      createdBy {\n        id name slug path __typename\n        openGraph { id image { id url } }\n        organisation {\n          id slug name path\n        }\n        photo {\n          id url\n        }\n      }\n      comments {\n        id __typename\n      }\n      embeds {\n        imageAssets {\n          id\n          slug\n          __typename\n          image {\n            id url url2x width height type\n          }\n        }\n        fileAssets {\n          id name slug __typename\n          file { id url formattedSize typeName }\n          thumbnail { id url url2x width height type }\n        }\n      }\n      type {\n        id name slug __typename\n      }\n    }\n  }\n"])));
export var useCommunityRequestsPollingQuery = function () {
  var _a = __read(useState(false), 2),
    isIdle = _a[0],
    setIsIdle = _a[1];
  // This state will be true until the very first data fetch completes successfully.
  var _b = __read(useState(true), 2),
    isInitialDataLoading = _b[0],
    setIsInitialDataLoading = _b[1];
  var initialFetchAttemptedRef = useRef(false);
  var _c = __read(useLazyQuery(ALL_COMMUNITY_REQUESTS_QUERY, {
      fetchPolicy: "network-only",
      pollInterval: isIdle ? 0 : 3000,
      notifyOnNetworkStatusChange: true,
      onCompleted: function () {
        // When data is successfully fetched for the first time, mark initial loading as complete.
        if (initialFetchAttemptedRef.current && isInitialDataLoading) {
          setIsInitialDataLoading(false);
        }
      },
      onError: function () {
        // Optionally, handle errors for the initial fetch, e.g., stop considering it initial loading.
        if (initialFetchAttemptedRef.current && isInitialDataLoading) {
          setIsInitialDataLoading(false);
        }
      }
    }), 2),
    fetchCommunityRequests = _c[0],
    _d = _c[1],
    data = _d.data,
    loading = _d.loading,
    error = _d.error,
    refetch = _d.refetch;
  useIdleTimer({
    onIdle: function () {
      return setIsIdle(true);
    },
    onActive: function () {
      return setIsIdle(false);
    },
    timeout: 10000
  });
  useEffect(function () {
    if (!initialFetchAttemptedRef.current) {
      fetchCommunityRequests();
      initialFetchAttemptedRef.current = true;
    }
  }, [fetchCommunityRequests]);
  var showPageLoader = isInitialDataLoading && loading;
  return {
    data: (data === null || data === void 0 ? void 0 : data.allCommunityRequests) || [],
    apolloLoading: loading,
    error: error,
    refetch: refetch,
    showPageLoader: showPageLoader
  };
};
var templateObject_1;